import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    card: {
        padding: theme.spacing(2),
        borderRadius: theme.shape.borderRadius,
        backgroundColor: '#EEEEEE',
    },
    titleProdutoPedido: {
        color: '#808080',
        fontSize: '15px',
        fontWeight: 600,
        // overflow: 'hidden',
        // whiteSpace: 'nowrap',
        // textOverflow: 'ellipsis'
    },
    subItem: {
        padding: theme.spacing(1),
        '&>div>p': {
            fontSize: 12
        }
    },
}))